module.exports = __webpack_public_path__ + "static/logo-main-7b0cb5c4443e301ce843eb7c3737a012.png";